export function isAppendixValid(appendix) {
	return !!(appendix?.name && (appendix?.text || appendix?.file));
}

export function isAppendixesValid(appendixes) {
	return appendixes?.length > 0 && appendixes.every(isAppendixValid);
}
